
class GoodReads {
    /**
	 * Create a new instance of a goodreads
	 * @param  {object} goodReadsData A goodreads object from novelist select
	 */
	constructor(goodReadsData) {
		//IsInGoodReads property is set to false by GoodReadsCacher, if a matching isbn is not found.
		this.isInGoodReads = goodReadsData.is_in_goodreads;		
		this.averageRating = goodReadsData.average_rating;
		this.reviewsCount = goodReadsData.work_text_reviews_count;
		this.isbn = goodReadsData.isbn13;		
		//this code has assumed that the Goodreads object only sets one link object in the array		
		//if this changes, the following lines will need to be modified to calculate which link to use
		this.goodReadsUrl = goodReadsData.links[0] ? goodReadsData.links[0].url : "";	
		this.loggingUrl = goodReadsData.links[0] ? goodReadsData.links[0].log_url : ""; 
	}
}

export default GoodReads;


// WEBPACK FOOTER //
// ./src/models/GoodReads.js